export default __webpack_public_path__ + "static/media/logo_main.10c8425b.svg";